module.exports = __webpack_public_path__ + "img/1.b17d4a84.jpg";